import { IconButton, TextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { DatePicker } from "@material-ui/pickers";
import { useTheme } from "@material-ui/styles";
import AddRowButton from "components/common/AddRowButton";
import {
  Bagde,
  StyledTableCell,
  TableRowHead,
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

export default function SpouseSection({
  defaultChildren,
  formik,
  bagdeStart = 14,
  colSpan = 7,
}) {
  const classes = useStyles();
  const theme = useTheme();
  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const canEdit = useSelector(canEditForm);
  const Childrens = get(formik.values, "document.Children", []);
  const Spouses = get(formik.values, "document.Spouse", []);

  const isDisabledSpouse = get(formik.values, "document.Marittal", "") !== "M";
  const isDisabledChildren =
    get(formik.values, "document.Marittal", "") === "S";

  return (
    <>
      <TableRowHead>
        <StyledTableCell>
          <div className={classes.cellContent}>
            <Bagde number={bagdeStart} />
            <div className={classes.wrapField}>
              <InputLabel>Spouse</InputLabel>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>Name</InputLabel>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>Date of birth</InputLabel>
        </StyledTableCell>
        <StyledTableCell>
          <InputLabel>Nationality</InputLabel>
        </StyledTableCell>
        <StyledTableCell colSpan={colSpan - 4}>
          <InputLabel>Occupation</InputLabel>
        </StyledTableCell>
      </TableRowHead>

      {Spouses.map((spouse, index) => (
        <TableRow key={index}>
          <StyledTableCell disabled={isDisabledSpouse || !canEdit}></StyledTableCell>
          <StyledTableCell disabled={isDisabledSpouse || !canEdit}>
            <TextField
              disabled={isDisabledSpouse || !canEdit}
              variant="outlined"
              className={classes.textField}
              name={`document.Spouse.${index}.SpouseName`}
              value={get(
                formik.values,
                `document.Spouse.${index}.SpouseName`,
                ""
              )}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={isError(`document.Spouse.${index}.SpouseName`, formik)}
              helperText={getErrorMessage(
                `document.Spouse.${index}.SpouseName`,
                formik
              )}
            />
          </StyledTableCell>
          <StyledTableCell disabled={isDisabledSpouse || !canEdit}>
            <DatePicker
              disabled={isDisabledSpouse || !canEdit}
              className={classes.formControl}
              style={{ width: 150 }}
              inputVariant="outlined"
              disableFuture
              openTo="year"
              format="DD-MM-YYYY"
              label="Date of birth"
              views={["year", "month", "date"]}
              name={`document.Spouse.${index}.SpouseBirthDate`}
              value={
                get(
                  formik.values,
                  `document.Spouse.${index}.SpouseBirthDate`,
                  null
                ) || null
              }
              onChange={(date) => {
                formik.setFieldValue(
                  `document.Spouse.${index}.SpouseBirthDate`,
                  date.format("YYYY-MM-DD")
                );
              }}
              error={isError(
                `document.Spouse.${index}.SpouseBirthDate`,
                formik
              )}
              helperText={getErrorMessage(
                `document.Spouse.${index}.SpouseBirthDate`,
                formik
              )}
            />
          </StyledTableCell>
          <StyledTableCell disabled={isDisabledSpouse || !canEdit}>
            <FormControl
              disabled={isDisabledSpouse || !canEdit}
              variant="outlined"
              className={classes.formControl}
              style={{ width: 200 }}
              error={isError(
                `document.Spouse.${index}.SpouseNationality`,
                formik
              )}
            >
              <InputLabel>Selected nationality</InputLabel>
              <Select
                label="Selected nationality"
                name={`document.Spouse.${index}.SpouseNationality`}
                value={get(
                  formik.values,
                  `document.Spouse.${index}.SpouseNationality`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={!canEdit}
              >
                {nationalityConfig.map((nationality) => (
                  <MenuItem
                    value={nationality.nationalityID}
                    key={nationality.nationalityID}
                  >
                    {nationality.nationalityName}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText
                error={isError(
                  `document.Spouse.${index}.SpouseNationality`,
                  formik
                )}
              >
                {getErrorMessage(
                  `document.Spouse.${index}.SpouseNationality`,
                  formik
                )}
              </FormHelperText>
            </FormControl>
          </StyledTableCell>
          <StyledTableCell disabled={isDisabledSpouse || !canEdit} colSpan={colSpan - 4}>
            <TextField
              disabled={isDisabledSpouse || !canEdit}
              variant="outlined"
              className={classes.textField}
              name={`document.Spouse.${index}.SpouseOccupation`}
              value={get(
                formik.values,
                `document.Spouse.${index}.SpouseOccupation`,
                ""
              )}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={isError(
                `document.Spouse.${index}.SpouseOccupation`,
                formik
              )}
              helperText={getErrorMessage(
                `document.Spouse.${index}.SpouseOccupation`,
                formik
              )}
            />
          </StyledTableCell>
        </TableRow>
      ))}

      {Childrens.map((children, index) => {
        if (!children.Status) return null;
        const activeIndex = Childrens.findIndex((v) => v.Status);
        return (
          <TableRow key={index}>
            {activeIndex === index ? (
              <StyledTableCell
                disabled={isDisabledChildren || !canEdit}
                rowSpan={Childrens.filter((v) => v.Status).length}
              >
                <div className={classes.cellContentWithRowSpan}>
                  <Bagde number={bagdeStart + 1} />
                  <div className={classes.wrapField}>
                    <InputLabel>Children</InputLabel>
                  </div>
                </div>
              </StyledTableCell>
            ) : null}

            <StyledTableCell disabled={isDisabledChildren || !canEdit}>
              <TextField
                disabled={isDisabledChildren || !canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.Children.${index}.ChildrenName`}
                value={get(
                  formik.values,
                  `document.Children.${index}.ChildrenName`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `document.Children.${index}.ChildrenName`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.Children.${index}.ChildrenName`,
                  formik
                )}
              />
            </StyledTableCell>
            <StyledTableCell disabled={isDisabledChildren}>
              <DatePicker
                disabled={isDisabledChildren || !canEdit}
                className={classes.formControl}
                style={{ width: 150 }}
                inputVariant="outlined"
                disableFuture
                openTo="year"
                format="DD-MM-YYYY"
                label="Date of birth"
                views={["year", "month", "date"]}
                name={`document.Children.${index}.ChildrenBrithDate`}
                value={
                  get(
                    formik.values,
                    `document.Children.${index}.ChildrenBrithDate`,
                    null
                  ) || null
                }
                onChange={(date) => {
                  formik.setFieldValue(
                    `document.Children.${index}.ChildrenBrithDate`,
                    date.format("YYYY-MM-DD")
                  );
                }}
                error={isError(
                  `document.Children.${index}.ChildrenBrithDate`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.Children.${index}.ChildrenBrithDate`,
                  formik
                )}
              />
            </StyledTableCell>
            <StyledTableCell disabled={isDisabledChildren}>
              <FormControl
                disabled={isDisabledChildren || !canEdit}
                variant="outlined"
                className={classes.formControl}
                style={{ width: 200 }}
                error={isError(
                  `document.Children.${index}.ChildrenNationality`,
                  formik
                )}
              >
                <InputLabel>Selected nationality</InputLabel>
                <Select
                  disabled={!canEdit}
                  label="Selected nationality"
                  name={`document.Children.${index}.ChildrenNationality`}
                  value={get(
                    formik.values,
                    `document.Children.${index}.ChildrenNationality`,
                    ""
                  )}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.nationalityID}
                      key={nationality.nationalityID}
                    >
                      {nationality.nationalityName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError(
                    `document.Children.${index}.ChildrenNationality`,
                    formik
                  )}
                >
                  {getErrorMessage(
                    `document.Children.${index}.ChildrenNationality`,
                    formik
                  )}
                </FormHelperText>
              </FormControl>
            </StyledTableCell>
            <StyledTableCell
              disabled={isDisabledChildren || !canEdit}
              colSpan={colSpan - 5}
            >
              <TextField
                disabled={isDisabledChildren || !canEdit}
                variant="outlined"
                className={classes.textField}
                name={`document.Children.${index}.ChildrenOccuption`}
                value={get(
                  formik.values,
                  `document.Children.${index}.ChildrenOccuption`,
                  ""
                )}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError(
                  `document.Children.${index}.ChildrenOccuption`,
                  formik
                )}
                helperText={getErrorMessage(
                  `document.Children.${index}.ChildrenOccuption`,
                  formik
                )}
              />
            </StyledTableCell>
            <StyledTableCell disabled={isDisabledChildren || !canEdit} align="center">
              {index === 0 ? (
                <div style={{ width: 40 }} />
              ) : (
                <>
                  <IconButton
                    style={{ width: 40, color: theme.palette.error.main }}
                    size="small"
                    onClick={async () => {
                      if (isDisabledChildren) return;
                      if (
                        get(
                          formik.values,
                          `document.Children[${index}].childrenId`,
                          ""
                        )
                      ) {
                        formik.setFieldValue(
                          `document.Children[${index}].Status`,
                          false
                        );
                      } else {
                        formik.setFieldValue(
                          "document.Children",
                          Childrens.filter((__, i) => i !== index)
                        );
                      }
                    }}
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                  <FormHelperText error={false}> </FormHelperText>
                </>
              )}
            </StyledTableCell>
          </TableRow>
        );
      })}
      <TableRow>
        <StyledTableCell disabled={isDisabledChildren || !canEdit} colSpan={colSpan}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <AddRowButton
              disabled={isDisabledChildren || !canEdit}
              onClick={() => {
                if (isDisabledChildren) return;
                formik.setFieldValue("document.Children", [
                  ...Childrens,
                  defaultChildren,
                ]);
              }}
            />
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
